/* Pias Antwort als Strom (03.11.2026): `POST /api/assistenz/thread/stream` liefert Server-Sent Events — werkzeug (Pia schlägt nach),
   text (Stück der Antwort), vorbereitet (Bestätigungskarte), zuletzt fertig {nachricht, antwort} wie `POST /thread`. axios streamt im
   Browser nicht, darum fetch mit denselben Kopfzeilen wie lib/api. */
import api from './api';
import { tokenStore } from './tokenStore';
import { getUmsatzToken } from './umsatz';

export async function piaStream(body, onEreignis) {
  const headers = { 'Content-Type': 'application/json', Accept: 'text/event-stream' };
  const token = tokenStore.getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const umsatz = getUmsatzToken();
  if (umsatz) headers['X-Umsatz-Token'] = umsatz;
  const res = await fetch(`${api.defaults.baseURL}/assistenz/thread/stream`, { method: 'POST', headers, credentials: 'include', body: JSON.stringify(body) });
  if (!res.ok || !res.body) {
    const fehler = new Error('Nicht gesendet');
    fehler.status = res.status;
    try { fehler.detail = (await res.json()).detail; } catch (e) { /* kein JSON */ }
    throw fehler;
  }
  const leser = res.body.getReader();
  const dekoder = new TextDecoder();
  let puffer = '';
  let ende = null;
  for (;;) {
    const { value, done } = await leser.read();
    if (done) break;
    puffer += dekoder.decode(value, { stream: true });
    let i;
    while ((i = puffer.indexOf('\n\n')) >= 0) {
      const block = puffer.slice(0, i);
      puffer = puffer.slice(i + 2);
      for (const zeile of block.split('\n')) {
        if (!zeile.startsWith('data: ')) continue;
        const e = JSON.parse(zeile.slice(6));
        if (e.typ === 'fertig' || e.typ === 'fehler') ende = e;
        else onEreignis(e);
      }
    }
  }
  if (!ende) { const fehler = new Error('Verbindung abgebrochen'); fehler.abgebrochen = true; throw fehler; }
  if (ende.typ === 'fehler') { const fehler = new Error(ende.detail); fehler.detail = ende.detail; throw fehler; }
  return ende;
}
